module.exports = __webpack_public_path__ + "img/lens-174-minus-06.f129e4ca.png";